<template>
  <div id="login">
    <div class="root_container">
      <div class="root_container__item logo_container">
        <div class="logo_container__item logo">
          <svg
            width="100"
            height="96"
            viewBox="0 0 100 96"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M48.9844 0.955673C48.1836 1.40577 48.1445 1.75802 48.0469 9.50753L47.9492 17.0026L30.2734 24.6152C20.5664 28.8226 12.4414 32.4234 12.207 32.6386C11.8164 33.03 11.8164 33.2453 11.7188 54.9674L11.6211 76.9048L6.34766 79.2531C0.878906 81.6602 0 82.2081 0 83.2257C0 84.3412 0.917969 85.2805 1.97266 85.2805C2.22656 85.2805 4.90234 84.1846 7.92969 82.8343C10.957 81.484 13.5547 80.3882 13.7109 80.3882C13.8477 80.3882 21.9336 83.8324 31.6602 88.0202C42.8516 92.8343 49.6094 95.6523 50 95.6523C50.3906 95.6523 57.1484 92.8343 68.3398 88.0202C78.0664 83.8324 86.1523 80.3882 86.2891 80.3882C86.4453 80.3882 89.043 81.484 92.0703 82.8343C95.0977 84.1846 97.7734 85.2805 98.0273 85.2805C99.082 85.2805 100 84.3412 100 83.2257C100 82.2081 99.1211 81.6602 93.6523 79.2531L88.3789 76.9048L88.2812 54.9674C88.1836 33.2453 88.1836 33.03 87.793 32.6386C87.5586 32.4234 79.4336 28.8226 69.7266 24.6152L52.0508 17.0026L51.9531 9.50753C51.8555 1.69931 51.8164 1.3862 50.9766 0.936104C50.5078 0.681702 49.4141 0.701271 48.9844 0.955673ZM48.0469 23.8324C48.0469 27.1788 48.418 27.942 50 27.942C51.582 27.942 51.9531 27.1788 51.9531 23.8324C51.9531 22.4429 51.9922 21.2884 52.0312 21.2884C52.1289 21.2884 80.6445 33.5975 80.9961 33.7932C81.2109 33.9107 80.8398 34.1455 79.6484 34.6543C78.7695 35.0261 71.7969 38.0398 64.1602 41.3471C54.8242 45.3784 50.1367 47.3158 49.8047 47.257C49.3945 47.1983 19.8438 34.4977 19.0039 34.0281C18.8086 33.9302 21.5234 32.6582 27.2852 30.1925C31.9922 28.1572 38.5156 25.3197 41.7969 23.9107C45.0781 22.4821 47.8125 21.3079 47.9102 21.3079C47.9883 21.2884 48.0469 22.4429 48.0469 23.8324ZM31.8555 43.8715L47.9492 50.8187L48.0078 70.7795C48.0273 81.7776 48.0078 90.76 47.9688 90.76C47.8711 90.76 19.3164 78.4508 18.9648 78.2355C18.6328 78.0594 18.7695 78.0007 23.1836 76.0437C25.4297 75.0653 25.9766 74.5565 25.9766 73.4997C25.9766 72.5017 25.1367 71.5819 24.2188 71.5819C23.8672 71.5819 22.1289 72.2277 20.2344 73.0692C18.3984 73.8911 16.6016 74.6934 16.2695 74.8304L15.625 75.1044V56.0242C15.625 45.5349 15.6641 36.9439 15.7031 36.9439C15.7422 36.9439 23.0078 40.0555 31.8555 43.8715ZM84.375 56.0242V75.1044L83.75 74.8304C83.3984 74.6934 81.6016 73.8911 79.7656 73.0692C77.8711 72.2277 76.1328 71.5819 75.7812 71.5819C74.8633 71.5819 74.0234 72.5017 74.0234 73.4997C74.0234 74.5565 74.5703 75.0653 76.8164 76.0437C81.2305 78.0007 81.3672 78.0594 81.0352 78.2355C80.6836 78.4508 52.1289 90.76 52.0312 90.76C51.9922 90.76 51.9727 81.7776 51.9922 70.7795L52.0508 50.8187L68.0664 43.8911C76.875 40.0946 84.1406 36.9635 84.2383 36.9635C84.3164 36.9439 84.375 45.5349 84.375 56.0242Z"
              fill="white"
            />
            <path
              d="M48.7305 32.521C48.1055 33.1472 47.9492 33.8713 48.2422 34.6149C48.5742 35.3781 49.1406 35.7695 50 35.7695C50.8594 35.7695 51.4258 35.3781 51.7578 34.6149C52.2656 33.3625 51.3672 32.0513 50 32.0513C49.4141 32.0513 49.082 32.1687 48.7305 32.521Z"
              fill="white"
            />
            <path
              d="M29.9805 68.9214C29.3555 69.5476 29.1992 70.2717 29.4922 71.0153C29.8242 71.7785 30.3906 72.1699 31.25 72.1699C32.1094 72.1699 32.6758 71.7785 33.0078 71.0153C33.5156 69.7629 32.6172 68.4517 31.25 68.4517C30.6641 68.4517 30.332 68.5691 29.9805 68.9214Z"
              fill="white"
            />
            <path
              d="M67.4805 68.9214C66.8555 69.5476 66.6992 70.2717 66.9922 71.0153C67.3242 71.7785 67.8906 72.1699 68.75 72.1699C69.6094 72.1699 70.1758 71.7785 70.5078 71.0153C71.0156 69.7629 70.1172 68.4517 68.75 68.4517C68.1641 68.4517 67.832 68.5691 67.4805 68.9214Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="logo_container__item logo_text">
          <svg
            width="220"
            height="39"
            viewBox="0 0 220 39"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.2607 2.95312V38.5H11.6221V2.95312H16.2607ZM27.6865 2.95312V6.81055H0.220703V2.95312H27.6865ZM46.0703 24.5596H36.5732V20.7266H46.0703C47.9095 20.7266 49.3988 20.4336 50.5381 19.8477C51.6774 19.2617 52.5075 18.4479 53.0283 17.4062C53.5654 16.3646 53.834 15.1764 53.834 13.8418C53.834 12.6211 53.5654 11.4736 53.0283 10.3994C52.5075 9.3252 51.6774 8.46257 50.5381 7.81152C49.3988 7.14421 47.9095 6.81055 46.0703 6.81055H37.6719V38.5H32.96V2.95312H46.0703C48.7559 2.95312 51.0264 3.41699 52.8818 4.34473C54.7373 5.27246 56.1452 6.55827 57.1055 8.20215C58.0658 9.82975 58.5459 11.6934 58.5459 13.793C58.5459 16.0716 58.0658 18.0166 57.1055 19.6279C56.1452 21.2393 54.7373 22.4681 52.8818 23.3145C51.0264 24.1445 48.7559 24.5596 46.0703 24.5596ZM68.7266 1V38.5H64.1855V1H68.7266ZM91.5537 33.9834V20.3848C91.5537 19.3431 91.3421 18.4398 90.9189 17.6748C90.512 16.8936 89.8936 16.2913 89.0635 15.8682C88.2334 15.445 87.208 15.2334 85.9873 15.2334C84.848 15.2334 83.847 15.4287 82.9844 15.8193C82.138 16.21 81.4707 16.7227 80.9824 17.3574C80.5104 17.9922 80.2744 18.6758 80.2744 19.4082H75.7578C75.7578 18.4642 76.002 17.5283 76.4902 16.6006C76.9785 15.6729 77.6784 14.8346 78.5898 14.0859C79.5176 13.321 80.6243 12.7188 81.9102 12.2793C83.2122 11.8236 84.6608 11.5957 86.2559 11.5957C88.1764 11.5957 89.8691 11.9212 91.334 12.5723C92.8151 13.2233 93.9707 14.208 94.8008 15.5264C95.6471 16.8285 96.0703 18.4642 96.0703 20.4336V32.7383C96.0703 33.6172 96.1436 34.5531 96.29 35.5459C96.4528 36.5387 96.6888 37.3932 96.998 38.1094V38.5H92.2861C92.0583 37.9792 91.8792 37.2874 91.749 36.4248C91.6188 35.5459 91.5537 34.7321 91.5537 33.9834ZM92.335 22.4844L92.3838 25.6582H87.8184C86.5326 25.6582 85.3851 25.764 84.376 25.9756C83.3669 26.1709 82.5205 26.472 81.8369 26.8789C81.1533 27.2858 80.6325 27.7985 80.2744 28.417C79.9163 29.0192 79.7373 29.7272 79.7373 30.541C79.7373 31.3711 79.9245 32.1279 80.2988 32.8115C80.6732 33.4951 81.2347 34.0404 81.9834 34.4473C82.7484 34.8379 83.6842 35.0332 84.791 35.0332C86.1745 35.0332 87.3952 34.7402 88.4531 34.1543C89.5111 33.5684 90.3493 32.8522 90.9678 32.0059C91.6025 31.1595 91.9443 30.3376 91.9932 29.54L93.9219 31.7129C93.8079 32.3965 93.4987 33.1533 92.9941 33.9834C92.4896 34.8135 91.8141 35.611 90.9678 36.376C90.1377 37.1247 89.1449 37.7513 87.9893 38.2559C86.8499 38.7441 85.5641 38.9883 84.1318 38.9883C82.3415 38.9883 80.7708 38.6383 79.4199 37.9385C78.0853 37.2386 77.0436 36.3027 76.2949 35.1309C75.5625 33.9427 75.1963 32.6162 75.1963 31.1514C75.1963 29.7354 75.473 28.4902 76.0264 27.416C76.5798 26.3255 77.3773 25.4222 78.4189 24.7061C79.4606 23.9736 80.7139 23.4202 82.1787 23.0459C83.6436 22.6715 85.2793 22.4844 87.0859 22.4844H92.335ZM114.234 12.084V15.5508H99.9521V12.084H114.234ZM104.786 5.66309H109.303V31.957C109.303 32.8522 109.441 33.5277 109.718 33.9834C109.994 34.4391 110.353 34.7402 110.792 34.8867C111.231 35.0332 111.703 35.1064 112.208 35.1064C112.582 35.1064 112.973 35.0739 113.38 35.0088C113.803 34.9274 114.12 34.8623 114.332 34.8135L114.356 38.5C113.998 38.6139 113.526 38.7197 112.94 38.8174C112.371 38.9313 111.679 38.9883 110.865 38.9883C109.758 38.9883 108.741 38.7686 107.813 38.3291C106.886 37.8896 106.145 37.1572 105.592 36.1318C105.055 35.0902 104.786 33.6904 104.786 31.9326V5.66309ZM126.271 38.5H121.754V9.30078C121.754 7.39648 122.096 5.79329 122.779 4.49121C123.479 3.17285 124.48 2.18001 125.782 1.5127C127.084 0.829102 128.631 0.487305 130.421 0.487305C130.942 0.487305 131.463 0.519857 131.983 0.584961C132.521 0.650065 133.041 0.747721 133.546 0.87793L133.302 4.56445C132.96 4.48307 132.569 4.42611 132.13 4.39355C131.707 4.361 131.284 4.34473 130.86 4.34473C129.9 4.34473 129.07 4.54004 128.37 4.93066C127.687 5.30501 127.166 5.8584 126.808 6.59082C126.45 7.32324 126.271 8.22656 126.271 9.30078V38.5ZM131.886 12.084V15.5508H117.579V12.084H131.886ZM135.719 25.585V25.0234C135.719 23.1191 135.995 21.3532 136.549 19.7256C137.102 18.0817 137.9 16.6576 138.941 15.4531C139.983 14.2324 141.244 13.2884 142.726 12.6211C144.207 11.9375 145.867 11.5957 147.706 11.5957C149.562 11.5957 151.23 11.9375 152.711 12.6211C154.208 13.2884 155.478 14.2324 156.52 15.4531C157.577 16.6576 158.383 18.0817 158.937 19.7256C159.49 21.3532 159.767 23.1191 159.767 25.0234V25.585C159.767 27.4893 159.49 29.2552 158.937 30.8828C158.383 32.5104 157.577 33.9346 156.52 35.1553C155.478 36.3597 154.216 37.3037 152.735 37.9873C151.271 38.6546 149.61 38.9883 147.755 38.9883C145.899 38.9883 144.231 38.6546 142.75 37.9873C141.269 37.3037 139.999 36.3597 138.941 35.1553C137.9 33.9346 137.102 32.5104 136.549 30.8828C135.995 29.2552 135.719 27.4893 135.719 25.585ZM140.235 25.0234V25.585C140.235 26.9033 140.39 28.1484 140.699 29.3203C141.008 30.4759 141.472 31.5013 142.091 32.3965C142.726 33.2917 143.515 33.9997 144.459 34.5205C145.403 35.0251 146.502 35.2773 147.755 35.2773C148.992 35.2773 150.074 35.0251 151.002 34.5205C151.946 33.9997 152.727 33.2917 153.346 32.3965C153.964 31.5013 154.428 30.4759 154.737 29.3203C155.063 28.1484 155.226 26.9033 155.226 25.585V25.0234C155.226 23.7214 155.063 22.4925 154.737 21.3369C154.428 20.165 153.956 19.1315 153.321 18.2363C152.703 17.3249 151.922 16.6087 150.978 16.0879C150.05 15.5671 148.959 15.3066 147.706 15.3066C146.469 15.3066 145.379 15.5671 144.435 16.0879C143.507 16.6087 142.726 17.3249 142.091 18.2363C141.472 19.1315 141.008 20.165 140.699 21.3369C140.39 22.4925 140.235 23.7214 140.235 25.0234ZM169.947 16.2344V38.5H165.431V12.084H169.825L169.947 16.2344ZM178.199 11.9375L178.175 16.1367C177.8 16.0553 177.442 16.0065 177.101 15.9902C176.775 15.9577 176.401 15.9414 175.978 15.9414C174.936 15.9414 174.016 16.1042 173.219 16.4297C172.421 16.7552 171.746 17.2109 171.192 17.7969C170.639 18.3828 170.2 19.0827 169.874 19.8965C169.565 20.694 169.361 21.5729 169.264 22.5332L167.994 23.2656C167.994 21.6706 168.149 20.1732 168.458 18.7734C168.784 17.3737 169.28 16.1367 169.947 15.0625C170.615 13.972 171.461 13.1257 172.486 12.5234C173.528 11.9049 174.765 11.5957 176.197 11.5957C176.523 11.5957 176.897 11.6364 177.32 11.7178C177.743 11.7829 178.036 11.8561 178.199 11.9375ZM186.866 17.333V38.5H182.325V12.084H186.622L186.866 17.333ZM185.938 24.291L183.839 24.2178C183.855 22.4111 184.091 20.7428 184.547 19.2129C185.003 17.6667 185.678 16.3239 186.573 15.1846C187.468 14.0452 188.583 13.1663 189.918 12.5479C191.253 11.9131 192.799 11.5957 194.557 11.5957C195.794 11.5957 196.933 11.7747 197.975 12.1328C199.016 12.4746 199.92 13.0199 200.685 13.7686C201.45 14.5173 202.044 15.4775 202.467 16.6494C202.89 17.8213 203.102 19.2373 203.102 20.8975V38.5H198.585V21.1172C198.585 19.7337 198.349 18.627 197.877 17.7969C197.421 16.9668 196.77 16.3646 195.924 15.9902C195.077 15.5996 194.085 15.4043 192.945 15.4043C191.611 15.4043 190.496 15.6403 189.601 16.1123C188.705 16.5843 187.989 17.2354 187.452 18.0654C186.915 18.8955 186.524 19.8477 186.28 20.9219C186.052 21.9798 185.938 23.1029 185.938 24.291ZM203.053 21.8008L200.025 22.7285C200.042 21.2799 200.278 19.8883 200.733 18.5537C201.205 17.2191 201.881 16.0309 202.76 14.9893C203.655 13.9476 204.754 13.1257 206.056 12.5234C207.358 11.9049 208.847 11.5957 210.523 11.5957C211.939 11.5957 213.193 11.7829 214.283 12.1572C215.39 12.5316 216.318 13.1094 217.066 13.8906C217.831 14.6556 218.409 15.6403 218.8 16.8447C219.19 18.0492 219.386 19.4814 219.386 21.1416V38.5H214.845V21.0928C214.845 19.6117 214.609 18.4642 214.137 17.6504C213.681 16.8203 213.03 16.2425 212.184 15.917C211.354 15.5752 210.361 15.4043 209.205 15.4043C208.212 15.4043 207.333 15.5752 206.568 15.917C205.803 16.2588 205.16 16.7308 204.64 17.333C204.119 17.9189 203.72 18.5944 203.443 19.3594C203.183 20.1243 203.053 20.9382 203.053 21.8008Z"
              fill="white"
            />
          </svg>
        </div>
      </div>

      <div class="root_container__item error_msg">
        <label v-if="errorMsg">{{ errorMsg }}</label>
      </div>

      <div class="root_container__item login_button">
        <button @click="goToLogin">Войти</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { keyclockUrl, keyclockRealm, keyclockClientId } from "@/config";
import {  getUserInfo } from "@/utils";
import {getSessions} from "@/api/api-service";
import {ErrorType, isApiError} from "@/api/api";

export default {
  name: "Login",
  components: {},
  data() {
    return {
      redirect_url: `${location.origin}/login`,
      errorMsg: null,
      userRights: [],
    };
  },

  methods: {
    goToLogin() {
      const url = `${keyclockUrl}/realms/${keyclockRealm}/protocol/openid-connect/auth?client_id=${keyclockClientId}&response_type=code&redirect_uri=${this.redirect_url}`;
      window.location.replace(url);
    },
    async login(code) {
      axios
        .post(`${this.$backEndUrl}/v1/auth/code`, {
          code: code,
          redirect_url: this.redirect_url,
        })
        .then(async (response) => {
          await this.$store.dispatch(
            "SAVE_AUTH_TOKEN",
            response.data.accessToken
          );
          await this.$store.dispatch(
            "SAVE_REFRESH_TOKEN",
            response.data.refreshToken
          );

          await getUserInfo(this.$http);
          await this.obtainRights();
          this.$router.push("/terminals");
        })
        .catch((error) => {
          console.log("Error to login", error);
          this.errorMsg = "Ошибка авторизации";
          this.$router.replace({ query: null });
        });
    },

    async validateGroups() {
      await this.$http
        .post(`${this.$backEndUrl}/v1/proxy/api`, {
          url: `/v3/groups?limit=1`,
          method: "GET",
          payload: {},
          headers: {},
        })
        .then((res) => {
          console.log(
            "Response from proxy api obtained (validate groups)",
            res
          );
          if (res.data.statusCode !== 403) {
            this.userRights.push("groups");
          }
        })
        .catch((error) => {
          console.log("Error to (validate groups)", error);
        });
    },

    async validateDistrs() {
      await this.$http
        .post(`${this.$backEndUrl}/v1/proxy/api`, {
          url: `/v2/distributions/types`,
          method: "GET",
          payload: {},
          headers: {},
        })
        .then((res) => {
          console.log("Response from proxy obtained (validate dist_types)");
          if (res.data.statusCode !== 403) {
            this.userRights.push("distributives");
            return;
          }
        })
        .catch((error) => {
          console.log("Error to (validate dist_types)", error);
        });
    },

    async validateImages() {
      await this.$http
        .post(`${this.$backEndUrl}/v1/proxy/api`, {
          url: `/v2/images/types`,
          method: "GET",
          payload: {},
          headers: {},
        })
        .then((res) => {
          console.log("Response from proxy obtained (validate image_types)");
          if (res.data.statusCode !== 403) {
            this.userRights.push("images");
          }
        })
        .catch((error) => {
          console.log("Error to (validate image_types)", error);
        });
    },

    async validatesTemplates() {
      await this.$http
        .post(`${this.$backEndUrl}/v1/proxy/api`, {
          url: `/v2/templates`,
          method: "GET",
          payload: {},
          headers: {},
        })
        .then((res) => {
          console.log("Response from proxy obtained (validate templates)");
          if (res.data.statusCode !== 403) {
            this.userRights.push("templates");
            return;
          }
        })
        .catch((error) => {
          console.log("Error to get templates", error);
        });
    },

    async validateTransport() {
      await this.$http
        .post(`${this.$backEndUrl}/v1/proxy/api`, {
          url: `/v2/transport/agents`,
          method: "GET",
          payload: {},
          headers: {},
        })
        .then((res) => {
          console.log("Response from proxy obtained (valdiate agents)");
          if (res.data.statusCode !== 403) {
            this.userRights.push("transport");
          }
        })
        .catch((error) => {
          console.log("Error to get (valdiate agents)", error);
        });
    },

    async validateSettings() {
      await this.$http
        .post(`${this.$backEndUrl}/v1/proxy/api`, {
          url: `/v2/setting/boot`,
          method: "GET",
          payload: {},
          headers: {},
        })
        .then((res) => {
          console.log(
            "Response from proxy api obtained (/v2/setting/boot)",
            res
          );
          if (res.status !== 403) {
            this.userRights.push("settings");
          }
        })
        .catch((error) => {
          console.log("Error to get (/v2/setting/boot)", error);
        });
    },
    async validateTerminals() {
      this.userRights.push("terminals");
    },
    async validateUSBInstaller() {
      const res = await getSessions(this.$http)
      if (isApiError(res) && res.errType === ErrorType.Forbidden) {
          return
      }
      this.userRights.push("usbInstaller");
    },
    async obtainRights() {
      await Promise.all([
        this.validateGroups(),
        this.validateDistrs(),
        this.validateImages(),
        this.validatesTemplates(),
        this.validateTransport(),
        this.validateSettings(),
        this.validateTerminals(),
        this.validateUSBInstaller()
      ]);
      await this.$store.dispatch("SET_USER_RIGHTS", this.userRights);
      console.log("User rights obtained");
    },
  },

  computed: {},

  async mounted() {
    // test if user is auth
    if (this.$store.getters.REFRESH_TOKEN) {
      if (await this.$store.dispatch("UPDATE_AUTH_TOKEN")) {
        await this.obtainRights();
        this.$router.push("/terminals");
      }
    }
    if (this.$route.query.code) {
      await this.login(this.$route.query.code);
    }
  },
};
</script>

<style lang="less">
body {
  background-color: #4150b7;
}

#login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
}

.root_container {
  width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo_container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .logo_container__item {
    flex: none;
    order: 1;
    flex-grow: 0;
  }
}

.error_msg {
  color: white;
}

.login_button {
  margin-top: 13px;
  button {
    height: 46px;
    width: 320px;
    background: #ffffff;
    cursor: pointer;
    border: 0.5px solid rgba(0, 0, 0, 0.12);
    border-radius: 10px;

    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.41px;
    color: 010101;
  }
}
</style>
